import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Followers',
  fields: {
    name: 'Name:',
    email: 'Email:',
    phone_number: 'Phone:',
    subscribed: 'Subscribed:',
    birthday: 'Birthday:',
    location: 'Location:',
    followed: 'Followed:',
    lifetime_spent: 'Lifetime spent:',
    total_orders: 'Total orders:',
    google_review: 'Google review:',
    loyalty_lifetime: 'Loyalty lifetime:',
    loyalty_points: 'Loyalty today:',
  },
  labels: {
    yes: 'Yes',
    no: 'No',
    followed_since_date: 'Since {{date}}',
  },
  buttons: {
    edit: 'Edit',
    request_data_deletion: 'Request data deletion',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
  },
  tabs: {
    recent_orders: {
      title: 'Recent orders',
      columns: {
        order_id: 'Id',
        items: 'Items',
        total: 'Total amount',
        paid_on: 'Paid on',
        payment_method: 'Payment method',
      },
      labels: {
        no_orders: 'No orders yet',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Card',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Bank debit',
        [PaymentMethods.CASH]: 'Cash',
        [PaymentMethods.BACS_DEBIT]: 'Bank debit',
      },
    },
    messages: {
      title: 'Messages',
      columns: {
        template: 'Template',
        status: 'Status',
        opened: 'Opened',
        clicked: 'Clicked',
        spam_complaint: 'Spam complaint',
        unsubscribed: 'Unsubscribed',
        sent_at: 'Sent at',
      },
      labels: {
        yes: 'Yes',
        no: 'No',
        not_detected: 'Not detected',
        opened_at: 'Opened at {{date}}',
        clicked_at: 'Clicked at {{date}}',
        complained_at: 'Complained at {{date}}',
        unsubscribed_at: 'Unsubscribed at {{date}}',
        no_messages: 'No messages yet',
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Sent',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Delivered',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Failed',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Failed to load data',
      },
    },
    balance_history: {
      title: 'Balance history',
      columns: {
        created_at: 'Date',
        source: 'Source',
        value: 'Points',
        points_expire_at: 'Expires at',
      },
      labels: {
        source: {
          welcome_bonus: 'Welcome bonus',
          google_review_reward: 'Google review reward',
          reward_loyalty_program_conversion: 'Loyalty program conversion reward',
          cashback: 'Cashback',
          refund: 'Refund',
          cashback_usage: 'Cashback usage',
          cashback_usage_refund: 'Cashback usage refund',
          expired_points_void: 'Expired points void',
          mobile_app_signup_bonus: 'Mobile app signup bonus',
        },
        no_operations: 'No operations yet',
      },
    },
  },
};
